import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M0 0h24v24H0z" }),
      _createElementVNode("path", {
        fill: "#007CC2",
        d: "M13.07 20.93 14 20l1-1 2-1 1-2v-1l-1-1-1-1h-2l-1 1-1 1v1l2 1-1 2-.661 1.983c-.113.004-.225.017-.339.017-4.96 0-9-4.04-9-9 0-2.94 1.42-5.55 3.6-7.19L6 6l1 1 1-1v1L7 9l4 4 2 1-2-2v-1l1-1 1 1 2-2V8l-1-2h-1v1h-1V6l1-1-1-1H8l.12-.12C9.3 3.32 10.61 3 12 3c4.96 0 9 4.04 9 9 0 4.597-3.473 8.398-7.93 8.93M12 2c-.78 0-1.54.09-2.26.26-.87.2-1.7.51-2.47.93C4.14 4.87 2 8.19 2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2"
      })
    ], -1)
  ]))]))
}
export default { render: render }